var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step edit-modes"},[_c('div',{staticClass:"step-description"},[_vm._v(_vm._s(_vm.$t('EDIT_MODE_DESCRIPTION')))]),_c('div',{staticClass:"step-image",style:({backgroundImage: 'url(' + this.image + ')'})})])}
var staticRenderFns = []

export { render, staticRenderFns }